import React, { useEffect, useState, createElement } from 'react';
import { YtMartesHero } from '../components/YtMartesHero';
import { YtMartesBenefits } from '../components/YtMartesBenefits';
import { YtMartesResults } from '../components/YtMartesResults';
import { YtMartesCTASection } from '../components/YtMartesCTASection';
import { YtMartesAuthorBio } from '../components/YtMartesAuthorBio';
import { YtMartesFooter } from '../components/YtMartesFooter';
import { FacebookPixel } from '../components/FacebookPixel';
import { YtMartesThankYouPage } from '../components/YtMartesThankYouPage';
import { NotificationToast } from '../components/NotificationToast';
import { trackEvent } from '../utils/analytics';
import { AlertTriangleIcon } from 'lucide-react';
export function YtMartesPage() {
  const [showThankYou, setShowThankYou] = useState(false);
  // Track page visit on mount
  useEffect(() => {
    trackEvent('page_visit');
  }, []);
  // Load Google Ads gtag.js
  useEffect(() => {
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11106102578';
    gtagScript.async = true;
    document.head.appendChild(gtagScript);
    const gtagInitScript = document.createElement('script');
    gtagInitScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-11106102578');
    `;
    document.head.appendChild(gtagInitScript);
    return () => {
      document.head.removeChild(gtagScript);
      document.head.removeChild(gtagInitScript);
    };
  }, []);
  if (showThankYou) {
    return <YtMartesThankYouPage data-id="element-1417" />;
  }
  return <div className="flex flex-col min-h-screen w-full bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-1418">
      <FacebookPixel pixelId="754551913878347" data-id="element-1419" />
      <NotificationToast data-id="element-1420" />
      <header className="fixed top-0 left-0 right-0 z-40 w-full px-4 py-2 bg-gray-900 bg-opacity-80 backdrop-blur-lg border-b border-gray-800 h-[88px]" data-id="element-1421">
        <div className="flex flex-col items-center justify-center h-full gap-0.5" data-id="element-1422">
          <div className="w-full max-w-[600px] h-[40px] flex items-center justify-center px-4" data-id="element-1423">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqSiWiuARq6wcs7g3ZrS3R/TRUSTED_BADGE.png" alt="Trusted by 1000+ Verified Customers" className="w-full h-auto max-h-[40px] object-contain" data-id="element-1424" />
          </div>
          <div className="w-[100px] h-[28px] flex items-center justify-center" data-id="element-1425">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full h-auto max-w-[100px]" width="100" height="28" data-id="element-1426" />
          </div>
        </div>
      </header>
      <main className="flex-grow w-full pt-[88px]" data-id="element-1427">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-1428">
          <div className="py-8 md:py-16 space-y-16 md:space-y-24" data-id="element-1429">
            <YtMartesHero isPaused={false} setShowThankYou={setShowThankYou} data-id="element-1430" />
            <YtMartesBenefits data-id="element-1431" />
            <YtMartesResults data-id="element-1432" />
            <YtMartesCTASection setShowThankYou={setShowThankYou} data-id="element-1433" />
            <YtMartesAuthorBio data-id="element-1434" />

            {/* Legal Disclaimer Section */}
            <section className="bg-gray-800 bg-opacity-50 rounded-2xl p-6 md:p-8 lg:p-10 shadow-2xl" data-id="element-1435">
              <div className="flex items-start mb-6" data-id="element-1436">
                <AlertTriangleIcon className="h-6 w-6 md:h-7 md:w-7 text-yellow-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-1437" />
                <h2 className="text-xl md:text-2xl font-bold text-yellow-300" data-id="element-1438">
                  Aviso Legal Importante
                </h2>
              </div>
              <div className="space-y-4 text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-1439">
                <p data-id="element-1440">
                  La información compartida en esta masterclass es con fines
                  educativos e informativos. No garantizamos resultados
                  específicos ni ingresos determinados.
                </p>
                <p data-id="element-1441">
                  Cualquier ejemplo de ingresos o resultados es solo ilustrativo
                  y se basa en experiencias personales o de algunos estudiantes.
                </p>
                <p data-id="element-1442">
                  Tus resultados dependerán de múltiples factores, incluyendo tu
                  experiencia, habilidades, esfuerzo, dedicación, situación
                  personal y condiciones de mercado.
                </p>
                <p data-id="element-1443">
                  Toda actividad de negocio conlleva riesgo, y es posible no
                  obtener resultados o incluso tener pérdidas.
                </p>
                <p className="font-semibold text-yellow-300" data-id="element-1444">
                  Al registrarte, aceptas que eres el único responsable de tus
                  decisiones, acciones y resultados.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <YtMartesFooter data-id="element-1445" />
    </div>;
}